import { Action } from 'redux';

import { SetExtractRefreshPriority } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IExtractTaskInfo } from '../../../extractTask/models/IExtractTaskInfo';

export interface SetExtractRefreshPriorityAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function setExtractRefreshPriority(tasks: IExtractTaskInfo[]): SetExtractRefreshPriorityAction {
  return {
    type: SetExtractRefreshPriority,
    tasks
  };
}
